import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class EventsService {
    accountRequestChanged = new EventEmitter<any>();
    data = new EventEmitter<any>();
    userChanged = new EventEmitter<any>();
    userDeleted = new EventEmitter<any>();
    userGroupChanged = new EventEmitter<any>();
    userGroupDeleted = new EventEmitter<any>();
    roleChanged = new EventEmitter<any>();
    roleDeleted = new EventEmitter<any>();
    agencyChanged = new EventEmitter<any>();
    agencyDeleted = new EventEmitter<any>();
    cameraChanged = new EventEmitter<any>();
    refreshCameras = new EventEmitter<any>();
    cameraDeleted = new EventEmitter<any>();
    centerChanged = new EventEmitter<any>();
    centerDeleted = new EventEmitter<any>();
    countyChanged = new EventEmitter<any>();
    countyDeleted = new EventEmitter<any>();
    locationChanged = new EventEmitter<any>();
    locationDeleted = new EventEmitter<any>();
    highwayChanged = new EventEmitter<any>();
    highwayDeleted = new EventEmitter<any>();
    vdsManagerChanged = new EventEmitter<any>();
    vdsManagerDeleted = new EventEmitter<any>();
    notificationTypeChanged = new EventEmitter<any>();
    wowzaAppTemplateChanged = new EventEmitter<any>();
    wowzaAppTemplateDeleted = new EventEmitter<any>();
    wowzaAppServerChanged = new EventEmitter<any>();
    wowzaAppServerDeleted = new EventEmitter<any>();
    wowzaServerSyncChanged = new EventEmitter<any>();
    eventsChanged = new EventEmitter<any>();
    eventDeleted = new EventEmitter<any>();
    eventTableUpdated = new EventEmitter<any>();
    newAccountsUpdated = new EventEmitter<any>();
    wallChanged = new EventEmitter<any>();
    refreshWallMarkers = new EventEmitter<any>();
    mobileCameraChanged = new EventEmitter<any>();
}
